'use client'

/**
 * Purpose: Video element + optional overlay for camera composers (internal primitive).
 * Inputs: videoRef, className, mirror, overlay children.
 * Outputs: Rendered live preview.
 */

import type { RefObject, ReactNode } from 'react'
import './Camera.css'

export type CameraPreviewProps = {
  videoRef: RefObject<HTMLVideoElement | null>
  className?: string
  videoClassName?: string
  mirror?: boolean
  overlay?: ReactNode
  id?: string
}

export function CameraPreview({ videoRef, className, videoClassName, mirror = false, overlay, id }: CameraPreviewProps) {
  // Live stream element plus optional scan framing overlay.
  return (
    <div id={id} className={`camera-preview ${className ?? ''}`}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        className={`camera-preview-video ${mirror ? 'camera-preview-video--mirror' : ''} ${videoClassName ?? ''}`}
      />
      {overlay ? <div className="camera-preview-overlay">{overlay}</div> : null}
    </div>
  )
}
